import script from "./FileDownloadView.vue?vue&type=script&setup=true&lang=js"
export * from "./FileDownloadView.vue?vue&type=script&setup=true&lang=js"

import "./FileDownloadView.vue?vue&type=style&index=0&id=ab644032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab644032"]])

export default __exports__